module.exports = __webpack_public_path__ + "static/media/pic6.eb6df6ac.jpg";